import gqls from "@/graphql/price.gql";

// callback 调用
import { resRest, easyMutate } from "@root/lib/utils";

import BbqActions from "@root/lib/bbqActions";
const shortAction = new BbqActions(gqls, []);
const gqlActions = shortAction.getValues();

const bonus = {
  namespaced: true,
  state: {},
  getters: {},
  actions: gqlActions,
  mutations: {
    easyMutate
  }
};
export default bonus;
